var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _path9, _rect5, _path10, _path11, _path12, _path13, _circle, _circle2, _circle3, _circle4, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraMonochromatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 550.07 504.01",
    "data-imageid": "camera-monochromatic",
    imageName: "Camera",
    className: "illustrations_image",
    style: {
      width: 237
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 292.11,
    y1: 116.93,
    x2: 328.02,
    y2: 116.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 341.65,
    y1: 105.93,
    x2: 343.19,
    y2: 132.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 236.05,
    y1: 423.23,
    x2: 259.52,
    y2: 241.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 280.91,
    y1: 296.72,
    x2: 266.94,
    y2: 135.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 375.95,
    y1: 148.06,
    x2: 478.41,
    y2: 148.06,
    gradientTransform: "translate(-4.46 13.55) rotate(-1.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 454.06,
    y1: 97.82,
    x2: 449.59,
    y2: 223,
    gradientTransform: "translate(-6.16 20.63) rotate(-2.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 458.55,
    y1: 178.27,
    x2: 513.69,
    y2: 122.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 241.22,
    y1: 200.62,
    x2: 485.86,
    y2: 200.62,
    gradientTransform: "translate(-7.52 14.28) rotate(-2.23)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 187.94,
    y1: 181.72,
    x2: 776.96,
    y2: 257.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 299.03,
    y1: 87.94,
    x2: 286.36,
    y2: 201.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 250.39,
    y1: 183.34,
    x2: 341.29,
    y2: 183.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 263.8,
    y1: 183.29,
    x2: 327.97,
    y2: 183.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 263.2,
    y1: 131.55,
    x2: 278.56,
    y2: 131.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 342.42,
    y1: 118.45,
    x2: 343.82,
    y2: 130.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 543.45,
    y1: 40.85,
    x2: 500.98,
    y2: 152.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-6"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "camera 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M101.79,407.65c-16-34.82-20.18-76.22-5.44-111.6,13.25-31.8,40.92-58,45.1-92.2,2.29-18.76-2.93-37.64-2.5-56.53.75-32.63,19-63.51,44.81-83.4s58.65-29.5,91.24-31.1c12.93-.64,26-.09,38.71-2.56,16.64-3.24,31.82-11.48,47.8-17.16C405.12-2.4,460,4.75,488.23,41.43c21.7,28.2,24.49,68.43,49.16,94.07,14.32,14.87,34.18,22.82,53.44,30.25,12.87,5,26.38,10.34,35,21.09,6.2,7.72,9.25,17.53,10.62,27.33,4.23,30.11-7.22,62-29.62,82.53-17,15.55-38.91,24.32-58.41,36.55s-37.89,30.32-40,53.24c-2.32,25.38,15.92,50.55,9.12,75.12-4.2,15.19-17.6,26.56-32.41,32s-31,5.63-46.72,4.83c-48.37-2.45-97.2-14.08-144.68-4.55-36.41,7.3-81,27.72-116.34,5.47C146.15,479.65,116.92,440.54,101.79,407.65Z",
    transform: "translate(-87.26 -5.4)",
    fill: "#68e1fd",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.75,112.93a5.5,5.5,0,0,0-3.15-.9c-8.66-.62-17.35-.66-26-.7a4.93,4.93,0,0,0-2,.27,4.61,4.61,0,0,0-1.27,1c-1.21,1.17-2.47,2.69-2.15,4.34a4.52,4.52,0,0,0,2.54,2.86c3.77,2.07,8.25,2.23,12.54,2.35l14.33.39c3.5.1,5.76-.11,6.28-4C328.09,116.71,328.32,114.22,326.75,112.93Z",
    transform: "translate(-87.26 -5.4)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326.75,112.93a5.5,5.5,0,0,0-3.15-.9c-8.66-.62-17.35-.66-26-.7a4.93,4.93,0,0,0-2,.27,4.61,4.61,0,0,0-1.27,1c-1.21,1.17-2.47,2.69-2.15,4.34a4.52,4.52,0,0,0,2.54,2.86c3.77,2.07,8.25,2.23,12.54,2.35l14.33.39c3.5.1,5.76-.11,6.28-4C328.09,116.71,328.32,114.22,326.75,112.93Z",
    transform: "translate(-87.26 -5.4)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335.3,106.72a1.13,1.13,0,0,1,.19-.54,1.15,1.15,0,0,1,.88-.32,108.63,108.63,0,0,1,12,0,1.22,1.22,0,0,1,.88.29,1.19,1.19,0,0,1,.22.76q.38,6.12.3,12.25c0,.24-10.8.31-11.79.3-1.29,0-2.87.37-3.24-1.17a20.16,20.16,0,0,1,0-4.91A57.23,57.23,0,0,1,335.3,106.72Z",
    transform: "translate(-87.26 -5.4)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M335.3,106.72a1.13,1.13,0,0,1,.19-.54,1.15,1.15,0,0,1,.88-.32,108.63,108.63,0,0,1,12,0,1.22,1.22,0,0,1,.88.29,1.19,1.19,0,0,1,.22.76q.38,6.12.3,12.25c0,.24-10.8.31-11.79.3-1.29,0-2.87.37-3.24-1.17a20.16,20.16,0,0,1,0-4.91A57.23,57.23,0,0,1,335.3,106.72Z",
    transform: "translate(-87.26 -5.4)",
    fill: "url(#linear-gradient-2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.32,386.25c-1.55,5.4.11,11.14.1,16.76,0,14.63-11.19,27.42-11.6,42.05a42,42,0,0,1-.29,6.74,27.15,27.15,0,0,1-2.85,7,128.44,128.44,0,0,0-9.81,25.65c-.45,1.7-.76,3.8.54,5,.93.85,14.64,14.1,15.88,14.39,38,8.94,85.68,2.23,101.67-16.26-6.52-31.3,9.18-64.27,1.69-95.36a5.15,5.15,0,0,0-1.09-2.46,5.38,5.38,0,0,0-3-1.25c-17.3-3.35-34.94-4.55-52.28-7.67C217.65,378.69,195.41,368.49,190.32,386.25Z",
    transform: "translate(-87.26 -5.4)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M221.66,402.59c13,6,27.82,6.8,42,5.42,5-.48,10.08-1.27,14.34-3.87s7.51-7.44,6.86-12.39a4.36,4.36,0,0,0-.88-2.29,5.55,5.55,0,0,0-2.61-1.41l-10.6-3.41c-3.46-1.11-6.93-2.23-10.49-3a111.91,111.91,0,0,0-14.26-1.85c-14.43-1.22-28.87-2.31-43.33-3.11-1.66-.09-3.51-.12-4.76,1-5.17,4.57,4.08,10,6.55,12.58A56.44,56.44,0,0,0,221.66,402.59Z",
    transform: "translate(-87.26 -5.4)",
    fill: "url(#linear-gradient-3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M291.56,309.52c-12.64,25.45-14.58,54.66-17.26,83-.4,4.29-1,9-4.26,11.88-2.83,2.53-6.93,2.94-10.72,2.93a73.55,73.55,0,0,1-33.17-8c-2.85-1.45-5.79-3.31-7-6.28-.93-2.39-.54-5.07-.14-7.6q7.45-47.07,14.93-94.15c1.25-7.88,3-16.62,9.5-21.26,5.07-3.62,11.76-3.75,18-3.75,7.44,0,44.35-4.52,48.13,1.73C314.68,276.36,295.2,302.2,291.56,309.52Z",
    transform: "translate(-87.26 -5.4)",
    fill: "#f1b475"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M261.58,275c-.16,4.63-2.06,9-3.92,13.22,1.07,2,3.57,2.9,5.84,2.74a16.74,16.74,0,0,0,6.39-2.24q8.87-4.57,17.28-10a40.53,40.53,0,0,0,6.79-5.14,22.62,22.62,0,0,0,6.39-12.49c-.19,1.24-28.32-2-31-1.88C258.43,259.73,261.87,266.86,261.58,275Z",
    transform: "translate(-87.26 -5.4)",
    fill: "url(#linear-gradient-4)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 251.95,
    y: 124.6,
    width: 233.19,
    height: 146.42,
    rx: 11.36,
    transform: "translate(-79 -20.08) rotate(2.31)",
    fill: "#68e1fd",
    className: "target-color"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 376.38,
    y: 133.65,
    width: 101.6,
    height: 28.82,
    transform: "translate(-82.37 -18.81) rotate(1.81)",
    fill: "url(#linear-gradient-5)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 386.08,
    y: 135.51,
    width: 35.39,
    height: 22.17,
    transform: "translate(-80.43 -22.99) rotate(2.52)",
    fill: "#68e1fd",
    className: "target-color"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 429.76,
    y: 137.37,
    width: 45.08,
    height: 23.1,
    transform: "translate(-80.29 -25.1) rotate(2.51)",
    fill: "url(#linear-gradient-6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M434.65,153.72A47.73,47.73,0,0,1,461.89,156a13.9,13.9,0,0,1,4.38,2.46,15.18,15.18,0,0,1,3.27,5c5.75,12.34,8.33,26,14,38.35a18.81,18.81,0,0,0,1.68-6.46,285.72,285.72,0,0,0,1.92-48.58c-.06-1.68-.27-3.61-1.64-4.57a5.33,5.33,0,0,0-2.58-.73,61.47,61.47,0,0,0-42.59,12.06",
    transform: "translate(-87.26 -5.4)",
    fill: "url(#linear-gradient-7)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 242.45,
    y: 166.44,
    width: 242.17,
    height: 68.36,
    transform: "translate(-79.18 -19.38) rotate(2.23)",
    fill: "url(#linear-gradient-8)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M306.17,149.4a65,65,0,0,1-21.74-12.56,84.53,84.53,0,0,1-22.12,18c2.85,6.37,10.77,8.2,16.86,11.59,10,5.56,15.87,16.38,19.69,27.15s6.2,22.16,11.75,32.15a21,21,0,0,1-15.95-2.25c1.33.58.33,2.73-1,3.23s-3.11.53-3.89,1.76-.15,2.65-.4,4c-.36,1.93-2.45,3.15-4.41,3.19a13.11,13.11,0,0,1-5.61-1.63c-2.77,3.45-3.33,8.15-3.5,12.58s-.07,9-1.87,13.06-6.21,7.37-10.5,6.27-6.39-5.68-7.55-9.86c-4.76-17.23-1.47-35.5-1.09-53.38.38-17.6-2.1-35.17-2-52.78,0-3.07.14-6.25,1.5-9s3.69-4.69,6-6.56q6.56-5.25,13.49-10c3-2,6.15-4.07,9.74-4.48,7.6-.89,13.94,5.5,18.5,11.64,3.09,4.14,10.61,9.2,12.55,13.46C317.59,151.52,310.59,150.9,306.17,149.4Z",
    transform: "translate(-87.26 -5.4)",
    fill: "url(#linear-gradient-9)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M265.62,88.57a25.18,25.18,0,0,1,6.14-5.2c2.8-1.48,6-1.85,9.18-2.11,23.77-2,48.88,1.1,68.74,14.31,1.8,1.2,3.79,3.25,2.86,5.21a4.31,4.31,0,0,1-2,1.77c-10.37,5.84-23.44,3.86-34.52-.5-2.58-1-14.05,0-16.81-.29-6.32-.69-12.15,3.08-17.5,6.51-11.32,7.24-14.28,11.49-26.53,17-4.17,1.87-9.53,3.48-12.75-.82a9.88,9.88,0,0,1-.57-10.7c2.46-4.16,7.08-7.71,10.39-11.19Z",
    transform: "translate(-87.26 -5.4)",
    fill: "#f1b475"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M265.62,88.57a25.18,25.18,0,0,1,6.14-5.2c2.8-1.48,6-1.85,9.18-2.11,23.77-2,48.88,1.1,68.74,14.31,1.8,1.2,3.79,3.25,2.86,5.21a4.31,4.31,0,0,1-2,1.77c-10.37,5.84-23.44,3.86-34.52-.5-2.58-1-14.05,0-16.81-.29-6.32-.69-12.15,3.08-17.5,6.51-11.32,7.24-14.28,11.49-26.53,17-4.17,1.87-9.53,3.48-12.75-.82a9.88,9.88,0,0,1-.57-10.7c2.46-4.16,7.08-7.71,10.39-11.19Z",
    transform: "translate(-87.26 -5.4)",
    fill: "url(#linear-gradient-10)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M201,271.54c-8.77-33.6-21.7-69.3-9.81-101.93,9.35-25.65,32.18-43.56,53.94-60.05,5.08-3.85,10.44-7.83,16.74-8.83,5.52-.87,11.12.66,16.45,2.37,10.68,3.43,21.31,7.76,29.88,15s18.42,18.07,18.27,29.29C310.07,160.05,294.59,126,278,129q-14.57,15.67-30.38,30.1a255,255,0,0,1,39.67-.52,336.78,336.78,0,0,1,28.2,64.77c-7.58,3.52-16.4-2.28-21.13-9.18s-7.54-15.27-13.79-20.82l12.66,36.81c.57,1.67,1.11,3.62.16,5.1-1.16,1.79-3.77,1.79-5.87,1.38A34.92,34.92,0,0,1,264.82,221c-9.85,8.8-7.45,24.39-5.87,37.5,5.36,44.51-5.1,104-24.88,144-12.29-5.59-26.82-13.22-26.52-23.25.26-8.42,4.4-16.16,5.4-24.51C216.11,328.22,207.68,297.13,201,271.54Z",
    transform: "translate(-87.26 -5.4)",
    fill: "#f1b475"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 295.84,
    cy: 183.34,
    r: 45.45,
    fill: "#68e1fd",
    className: "target-color"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.84,
    cy: 183.34,
    r: 45.45,
    fill: "url(#linear-gradient-11)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.88,
    cy: 183.29,
    r: 32.08,
    fill: "url(#linear-gradient-12)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.88,
    cy: 131.55,
    r: 7.68,
    fill: "url(#linear-gradient-13)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M352,117.51a4.73,4.73,0,0,1,1.75.37,3.5,3.5,0,0,1,1.71,2.68,10.75,10.75,0,0,1-.21,3.34,1,1,0,0,1-.29.66.92.92,0,0,1-.52.1L343,124.6c-3.24,0-7.84.85-10.94-.13-2.44-.77-2.11-3.46-1.79-5.63.4-2.68,1.38-2.27,3.74-2.27,1.9,0,3.81.06,5.71.14C343.79,116.88,347.9,117.51,352,117.51Z",
    transform: "translate(-87.26 -5.4)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M352,117.51a4.73,4.73,0,0,1,1.75.37,3.5,3.5,0,0,1,1.71,2.68,10.75,10.75,0,0,1-.21,3.34,1,1,0,0,1-.29.66.92.92,0,0,1-.52.1L343,124.6c-3.24,0-7.84.85-10.94-.13-2.44-.77-2.11-3.46-1.79-5.63.4-2.68,1.38-2.27,3.74-2.27,1.9,0,3.81.06,5.71.14C343.79,116.88,347.9,117.51,352,117.51Z",
    transform: "translate(-87.26 -5.4)",
    fill: "url(#linear-gradient-14)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M438.61,87.08s43,14.53,76-29.62c0,0-3.91,65.38,65.39,25.7,0,0-46.39,44.71.56,76.57,0,0-78.24-37.45-77.68,41.35,0,0-10.62-68.74-68-47.5C434.88,153.58,493.93,133.46,438.61,87.08Z",
    transform: "translate(-87.26 -5.4)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M442.52,83.35s43,14.53,76-29.62c0,0-3.91,65.39,65.39,25.71,0,0-46.39,44.71.56,76.56,0,0-78.24-37.44-77.68,41.36,0,0-10.62-68.74-68-47.51C438.79,149.85,497.85,129.74,442.52,83.35Z",
    transform: "translate(-87.26 -5.4)",
    fill: "url(#linear-gradient-15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraMonochromatic);
export default __webpack_public_path__ + "static/media/camera-monochromatic.43329fb6e6d97e0d0086eae718516751.svg";
export { ForwardRef as ReactComponent };